import { action } from "typesafe-actions";
import {
  FetchPortfoliosPayload,
  FetchPortfoliosResponse,
  FETCH_PORTFOLIOS_BY_ID,
  FETCH_PORTFOLIOS,
  FETCH_PORTFOLIOS_SUCCESS,
  DELETE_EXCLUDE_PORTFOLIO_LIST_REQUEST,
  DELETE_EXCLUDE_PORTFOLIO_LIST_SUCCESS,
  DELETE_EXCLUDE_PORTFOLIO_LIST_FAILURE,
  RESET_EXCULDE_PORTFOLIO_STATUS,
} from "./types";

export const fetchPortfolios = (payload: FetchPortfoliosPayload) =>
  action(FETCH_PORTFOLIOS, payload);

export const fetchPortfoliosSuccess = (payload: FetchPortfoliosResponse) => {
  return action(FETCH_PORTFOLIOS_SUCCESS, payload);
};

export const fetchPortfoliosById = (payload: string[]) =>
  action(FETCH_PORTFOLIOS_BY_ID, payload);

export const deleteExcludePortfolioListRequest = (portfolioIds: string[]) => ({
  type: DELETE_EXCLUDE_PORTFOLIO_LIST_REQUEST,
  payload: portfolioIds,
});

export const deleteExcludePortfolioListSuccess = (portfolioIds: string[]) => ({
  type: DELETE_EXCLUDE_PORTFOLIO_LIST_SUCCESS,
  payload: portfolioIds,
});

export const deleteExcludePortfolioListFailure = (error: string) => ({
  type: DELETE_EXCLUDE_PORTFOLIO_LIST_FAILURE,
  payload: error,
});

export const resetExcludePortfolioStatus = () => ({
  type: RESET_EXCULDE_PORTFOLIO_STATUS,
  payload: null,
});
